module.exports = __webpack_public_path__ + "img/Group 27964@2x.7a11aa91.png";